import antdData from 'antd/lib/locale-provider/es_ES'
import localeData from 'react-intl/locale-data/es'

const messages = {
    
   'sec1.header1' : 'DESCUBRE LA TRAZABILIDAD',
   'sec1.header2' : 'DE TU JOYA TOUS',
   'sec1.text' : 'Hablar de sostenibilidad es hablar de trazabilidad. En TOUS, somos pioneros en presentar la trazabilidad completa de una joya, desde la compañía minera hasta que llega a ti. Con Tracemark, tienes la certeza de que tu joya es 100% ética y sostenible, de principio a fin.',

   'sec2.description' : 'Descripción',
   'sec2.button' : 'ID DIGITAL',

   'rawMaterials.header' : 'Materias primas',
   'rawMaterials.header.text' : 'Oro y diamantes de abastecimiento responsable.',

   'rawMaterials.sec1.header1' : 'Oro 100% ético',
   'rawMaterials.sec1.header2' : 'y reciclado',
   'rawMaterials.sec1.text1' : 'Esta pieza está hecha con oro 100% ético, reciclado y de origen responsable, proveniente de refinerías que sólo trabajan con oro CoC (Cadena de Custodia). La norma de RJC (Responsible Jewellery Council) Chain of Custody garantiza que el oro ha sido extraído de manera sostenible y siguiendo el Código de Prácticas de RJC.',
   'rawMaterials.sec1.text2' : 'El oro utilizado en esta pieza de joyería proviene de fuentes que han sido verificadas como que cumplen con las mejores prácticas ambientales internacionales y estándares sociales reconocidos en todo el mundo.',
   'rawMaterials.sec1.notTraceableMaterial' : 'Material sin trazabilidad Tracemark:',

   'rawMaterials.sec2.header1' : 'Diamantes',
   'rawMaterials.sec2.header2' : 'trazables de',
   'rawMaterials.sec2.header3' : 'origen responsable',
   'rawMaterials.sec2.text1.1' : 'Los diamantes de esta joya provienen de la compañía minera ',
   'rawMaterials.sec2.text1.2' : ', miembro certificado de RJC o DeBeers Sightholder, que garantiza el abastecimiento responsable y el cumplimiento de prácticas sostenibles y éticas a lo largo de toda la cadena de suministro.',
   'rawMaterials.sec2.text2' : 'El país de origen de los diamantes es ',
   'rawMaterials.sec2.text3' : 'Cada diamante está verificado por su propio Certificado de Proceso Kimberly, que verifica su autenticidad, procedencia y extracción ética.',
   'rawMaterials.sec2.text4.1' : 'La',
   'rawMaterials.sec2.text4.2' : 'Certificación del Proceso de Kimberley',
   'rawMaterials.sec2.text4.3' : 'impone requisitos extensos a sus miembros para permitirles certificar los envíos de diamantes en bruto como "libres de conflictos" y evitar que los diamantes en conflicto entren en el comercio legítimo.', 

   'fabricationProcess.header1' : 'Proceso de fabricación:',
   'fabricationProcess.header2' : 'EL ARTE DE LA MANUFACTURA',

   'fabricationProcess.text1' : 'La manufactura de una joya empieza inspirándose en una emoción o idea que se convierte en diseño. Expertos joyeros convierten ese esbozo en una joya única a través de un proceso de fabricación que recoge la tradición del oficio e incorpora innovadoras técnicas de producción. Esta pieza está fabricada en Córdoba, en el sur de España. Desde el modelado y la fundición hasta el repasado, el engastado y el pulido, nuestros artesanos cordobeses van dando forma a esta joya con la pasión del oficio y experta dedicación.',
   'fabricationProcess.text2' : 'Toda la documentación e información sobre la trazabilidad de esta joya ha sido verificada por un auditor externo acreditado por RJC.',

   'certificates' : 'Certificados',
   'download' : 'DESCARGAR',


   'digitalPass.header' : 'Obtenga su Tracemark ID',
   'digitalPass.step1' : 'Autentifique su joya',
   'digitalPass.step2' : 'Genere su Tracemark ID',

   'digitalPass.uniqueCode' : 'Código alfanumérico único como aparece grabado en su joya y en la etiqueta de la misma',
   'digitalPass.Authenticate' : 'Autentificar',

   'digitalPass.personalDetails' : 'Detalles personales',
   'digitalPass.email' : 'email',
   'digitalPass.firstName' : 'Nombre',
   'digitalPass.lastName' : 'Apellido',
   'digitalPass.password.text1' : 'Establezca una contraseña',
   'digitalPass.password.text2' : 'Establezca una contraseña para acreditar la propiedad de su joya y obtener su Tracemark ID.',
   'digitalPass.password' : 'Contraseña',
   'digitalPass.confirmPassword' : 'Confirmar contraseña',
   'digitalPass.generateTracemarkIDButton' : 'Obtener Tracemark ID',

   'digitalPass.notificationHeader' : 'Descargando Tracemark ID',
   'digitalPass.notificationText' : 'También recibirá su Tracemark ID por email. Por favor, descárguelo utilizando su teléfono móvil para guardarlo automáticamente en formato Passbook.',
   
   'digitalPass.termsAndCondition1' : 'He leído y acepto de forma expresa la',
   'digitalPass.termsAndCondition2' : 'de “TRACEABLE LUXURY SERVICES, S.L.” y las condiciones del tratamiento de mis datos personales.',

   /* ----------- Start Delete TracemarkID Popup ------------- */

   'deleteTracemarkID.link' : 'Restablecer la propiedad de esta joya y liberar Tracemark ID',
   'deleteTracemarkID.modal.header' : 'Restablecido Tracemark ID',
   
   'deleteTracemarkID.step1.password' : 'Introduzca su contraseña',
   'deleteTracemarkID.step1.button' : 'Validar',
   'deleteTracemarkID.step1.forgotPasswordLink' : 'He olvidado mi contraseña',

   'deleteTracemarkID.step2.resetText' : 'Escriba RESET para restablecer la propiedad de su Tracemark ID en caso de devolución o entrega a un nuevo propietario.',
   
   'deleteTracemarkID.step3.success' : 'Gracias. La propiedad y el Tracemark ID para esta joya se han restablecido.',

   /* ----------- End Delete TracemarkID Popup ------------- */

   'downloadCertificate.text1' : 'Para descargarte el certificado de Tracemark de esta pieza, por favor introduce la contraseña utilizada para registrar la joya. Esta es la contraseña que habilitaste para obtener tu Tracemark ID.',
   'downloadCertificate.text2' : 'Si no has registrado tu joya, puedes hacerlo directamente desde el panel de trazabilidad, junto al apartado de Tracemark ID.',

   'downloadCertificate.success' : 'En breve recibirás un correo electrónico con el certificado de Tracemark de esta joya adjunto, a la dirección de correo utilizada para registrar su propiedad.',

   'downloadCertificate.title' : "Descargar certificado",
   'Consumer.download' : 'Descargar',

   /* ----------- Start Tous version 2(v2) changes ------------- */ 
   'rawMaterials.sec2.v2.text1':'Los diamantes de esta pieza de joyería provienen de un tallador de diamantes miembro de De Beers Sightholders, garantizando prácticas de abastecimiento responsables y el cumplimiento de prácticas sostenibles a lo largo de la cadena de suministro.',
   'rawMaterials.sec2.v2.text2':'Cada diamante está verificado por su propio Certificado de Proceso Kimberly, que verifica su autenticidad, procedencia y extracción ética.',
   'rawMaterials.sec2.v2.text3':'La Certificación del Proceso de Kimberley impone requisitos extensos a sus miembros para permitirles certificar los envíos de diamantes en bruto como "libres de conflictos" y evitar que los diamantes en conflicto entren en el comercio legítimo.'
   /* ----------- End Tous version 2(v2) changes ------------- */
}

export default {
  locale: 'es-ES',
  antdData,
  localeData,
  messages,
}
